export type PollingState = {
    description: string,
    id: number,
    state: PollingStateStatus,
    timestamp: string,
}

export const enum PollingStateStatus {
    FINISHED = "finished",
    ERROR = "error_fetching_items",
    PENDING = "pending"
}

export const poll = async (promiseFn, returnFn, cbFn, catchFn, timeoutMs = 60000) => {
    // accepts "promiseFn" which is primary promise we are initiating and want to poll the results of
    // returnFn is what we want to do with the data that is returned from each step
    // cbFn (callback) is run when state is finished

    let step = 0;
    const currentStateObject: Array<PollingState> = [];
    let currentState;
    const start = Date.now();

    const loopFn = async () => {

        try {
            if (Date.now() - start > timeoutMs) {
                throw new Error('Polling timed out');
            }

            const res: {
                data: Array<PollingState>,
                links: {
                    next: null | string,
                },
                meta: {
                    total: number,
                }
            } = await promiseFn();

            if (res.data.length > 0) {
                if (currentStateObject.length === 0 || (currentStateObject[currentStateObject.length-1].state !== res.data[res.data.length-1].state)) {
                    currentStateObject.push(res.data[res.data.length-1]);
                }
            }
            currentState = currentStateObject[step];

            if (currentState && (currentState.state === PollingStateStatus.FINISHED || currentState.state === PollingStateStatus.ERROR)) {
                return cbFn(currentStateObject[step]);
            } else {
                setTimeout(async () => {
                    // it's very possible we create a race condition here, so we should locally save the state object to be sure
                    // we always have a complete set of data
                    if (currentStateObject.length > step + 1) {
                        step++;
                    }

                    returnFn(currentStateObject[step]);
                    await loopFn();
                }, 1000);
            }
        }
        catch (error) {
            catchFn(error);
        }
    };
    await loopFn()
        .catch(catchFn)
};

export function isJson(str): str is string {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
}
